import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "summary-top-intro"
}
const _hoisted_2 = { class: "summary-top-intro-content" }
const _hoisted_3 = { class: "my-report-top-date-wrapper" }
const _hoisted_4 = { class: "my-report-top-date-list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  class: "my-report-top-date-change-icon"
}
const _hoisted_8 = { class: "my-reports" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "my-report-item condition" }
const _hoisted_11 = {
  key: 0,
  class: "item-condition-recorded"
}
const _hoisted_12 = {
  key: 1,
  class: "item-unrecordable"
}
const _hoisted_13 = { class: "item-unrecordable-text" }
const _hoisted_14 = {
  key: 2,
  class: "item-condition-unrecorded"
}
const _hoisted_15 = { class: "item-top" }
const _hoisted_16 = { class: "item-title" }
const _hoisted_17 = { class: "item-title-text" }
const _hoisted_18 = { class: "item-unrecorded" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "item-unrecorded-note" }
const _hoisted_22 = { class: "my-report-item treatment" }
const _hoisted_23 = { class: "item-top" }
const _hoisted_24 = { class: "item-title" }
const _hoisted_25 = { class: "item-title-text" }
const _hoisted_26 = {
  key: 0,
  class: "item-treatment-content-recorded"
}
const _hoisted_27 = { class: "item-treatment-change-list" }
const _hoisted_28 = { class: "row-date" }
const _hoisted_29 = { class: "row-detail" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  key: 1,
  class: "item-unrecordable"
}
const _hoisted_32 = { class: "item-unrecordable-text" }
const _hoisted_33 = {
  key: 2,
  class: "item-treatment-content-unrecorded"
}
const _hoisted_34 = { class: "item-treatment-change-text" }
const _hoisted_35 = { class: "my-report-item symptom" }
const _hoisted_36 = { class: "item-top" }
const _hoisted_37 = { class: "item-title" }
const _hoisted_38 = { class: "item-title-text" }
const _hoisted_39 = {
  key: 0,
  class: "item-recorded"
}
const _hoisted_40 = { class: "item-daily-note" }
const _hoisted_41 = { class: "row-text" }
const _hoisted_42 = { class: "row-bottom" }
const _hoisted_43 = { class: "row-bottom-date" }
const _hoisted_44 = { class: "item-daily-note-more-wrapper" }
const _hoisted_45 = {
  key: 1,
  class: "item-unrecordable"
}
const _hoisted_46 = { class: "item-unrecordable-text" }
const _hoisted_47 = {
  key: 2,
  class: "item-unrecorded"
}
const _hoisted_48 = ["innerHTML"]
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = { class: "item-unrecorded-note" }
const _hoisted_51 = { class: "my-report-item feeling" }
const _hoisted_52 = {
  key: 0,
  class: "feeling-chart-wrapper"
}
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { class: "item-top" }
const _hoisted_55 = { class: "item-title" }
const _hoisted_56 = { class: "item-title-text" }
const _hoisted_57 = { class: "item-unrecordable" }
const _hoisted_58 = { class: "item-unrecordable-text" }
const _hoisted_59 = { key: 2 }
const _hoisted_60 = { class: "item-top" }
const _hoisted_61 = { class: "item-title" }
const _hoisted_62 = { class: "item-title-text" }
const _hoisted_63 = { class: "item-unrecorded" }
const _hoisted_64 = ["innerHTML"]
const _hoisted_65 = ["innerHTML"]
const _hoisted_66 = { class: "item-unrecorded-note" }

import dayjs from "dayjs";
import "dayjs/locale/ja";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

import {
  onMounted,
  onBeforeUnmount,
  nextTick,
  computed,
  watch,
  ref,
  reactive,
} from "vue";
import { processing, processend } from "@/utils/view";
import router from "@/router";

import ConditionLineChart from "@/views/base/Chart/ConditionLineChart.vue";
import FeelingDoughnutChart from "@/views/base/Chart/FeelingDoughnutChart.vue";
import MyGraph from "@/models/myReport/myGraph";
import TreatmentHistory from "@/views/pages/MyRecord/Treatment/TreatmentHistory.vue";
import TreatmentTips from "@/views/pages/MyReport/TreatmentTips.vue";
import ErrorDialog from "@/views/base/CommonMessage.vue";

// 日付のローカライズ
type DailyNote = {
  id: string;
  checked: boolean;
  content: string;
  date: string;
  categoryClass: string;
  categoryLabel: string;
};

// 日々の気持ちデータ
type DailyFeeling = {
  code: number;
  name: string;
  value: number;
};

// 治療データ
type Treatment = {
  id: number;
  subNumber: number;
  title: string;
  burdenOfMedicine: string;
  detail: string;
  status: string;
  effect: string;
  date: string;
  isNew: boolean;
};

// 期間キー
type RangeKey = "1w" | "1m" | "3m" | "6m" | "1y";

// 生データ型
type RawItem = {
  dates: string;
  chartData:
    | { value: number; condition: string; color?: string; size?: number }
    | { value: number; condition: string; color?: string; size?: number }[]
    | null;
};

// 治療ID
type TreatmentIds = {
  userTreatmentId: number;
  subNumber: number;
};

// 治療履歴モーダルのprops
type TreatmentModalProps = {
  diseaseOptions: { id: string; name: string }[];
  selectedTreatmentIds: TreatmentIds | null;
};

// ---- Constants & Variables ------------------------------
const _MAX_DISPLAY_COUNT = 3;

// 表示制御
const mobileBreakpoint = 767;
// 体調グラフのタイトルサイズは親画面側で制御する（ConditionLineChartへpropsで渡す）

export default /*@__PURE__*/_defineComponent({
  __name: 'MyGraph',
  setup(__props) {

dayjs.locale("ja");

// 日付の比較プラグインを有効にする
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

// ---- Types ----------------------------------------------

// 症状・こころノートデータ
const initialReadFlag = ref<boolean>(true); // 初回閲覧フラグ
const isDataStored = ref<boolean>(false); // データ取得済みフラグ
const isTreatmentHistory = ref<boolean>(false); // 治療履歴モーダル表示フラグ
const isTreatmentTips = ref<boolean>(false); // 治療状況の見方ポップアップ表示フラグ
// 表示データ
const bodyConditions = ref<RawItem[]>([]); // 体調データ
const dailyNoteItems = ref<Array<DailyNote>>([]); // 症状・こころノート
const treatmentItems = ref<Array<Treatment>>([]); // 治療の変化
const dailyFeelingItems = ref<Array<DailyFeeling>>([]); // 日々の気持ち

// 表示期間
const periodStart = ref(dayjs().subtract(6, "day").format("YYYY-MM-DD")); // 表示開始日
const periodEnd = ref(dayjs().format("YYYY-MM-DD")); // 表示終了日
const startDate = computed(() => dayjs(periodStart.value).format("M月D日")); // 表示開始日（月日）
const endDate = computed(() => dayjs(periodEnd.value).format("M月D日")); // 表示終了日（月日）

// 日付バー固定制御
const dateChangeRef = ref<HTMLElement | null>(null);
const dateChangeTriggerRef = ref<HTMLElement | null>(null);
const isDateChangeFixed = ref(false);
const isMobileScreen = ref(window.innerWidth <= mobileBreakpoint);
let wrapperEl: HTMLElement | null = null;
const activeRange = ref<RangeKey>("1w"); // 選択中の期間

// 治療履歴モーダル関連
const treatmentModalProps = reactive<TreatmentModalProps>({
  diseaseOptions: [],
  selectedTreatmentIds: null,
});

// 期間選択タブ用マップ
const rangeMap: Record<RangeKey, { key: RangeKey; label: string }> = {
  "1w": { key: "1w", label: "1週間" },
  "1m": { key: "1m", label: "1ヶ月" },
  "3m": { key: "3m", label: "3ヶ月" },
  "6m": { key: "6m", label: "半年" },
  "1y": { key: "1y", label: "1年" },
};

// 期間移動用マップ
const periodMap: Record<string, { value: number; unit: dayjs.ManipulateType }> =
  {
    "1w": { value: 6, unit: "day" },
    "1m": { value: 29, unit: "day" },
    "3m": { value: 89, unit: "day" },
    "6m": { value: 179, unit: "day" },
    "1y": { value: 364, unit: "day" },
  };

// 体調ラベル
const titleCond = reactive({
  show: true,
  pos: {
    left: "0",
    top: "0",
  },
  textStyle: {
    fontFamily: "Zen Maru Gothic, sans-serif",
    fontSize: isMobileScreen.value ? "16px" : "18px",
    fontWeight: 300,
  },
});

// 平均体調
const titleAvg = reactive({
  show: true,
  pos: {
    right: "60px",
    top: "10px",
  },
  textStyle: {
    fontFamily: "Zen Maru Gothic, sans-serif",
    fontSize: isMobileScreen.value ? "14px" : "16px",
    fontWeight: 300,
  },
});

// ---- Dialogs --------------------------------------------

// エラーダイアログ関連情報
const sessionErr = ref(false);
let errorDialogSet = reactive({
  show: false,
  okButtonHide: true,
  safe: false,
  message: "",
  open: (message: string): void => {
    processing(); // オーバレイを表示
    errorDialogSet.message = message;
    errorDialogSet.show = true;
  },
  close: (): void => {
    processend(); // オーバレイを非表示
    errorDialogSet.show = false;
    errorDialogSet.message = "";
    if (sessionErr.value) {
      window.location.replace("/cms/login");
    }
  },
});

// ---- Functions ------------------------------------------

// 前期間移動
function prevPeriod() {
  const start = dayjs(periodStart.value);
  const end = dayjs(periodEnd.value);

  const { value, unit } = periodMap[activeRange.value];

  periodStart.value = start.subtract(value, unit).format("YYYY-MM-DD");
  periodEnd.value = end.subtract(value, unit).format("YYYY-MM-DD");
}

// 次期間移動
function nextPeriod() {
  const start = dayjs(periodStart.value);
  const end = dayjs(periodEnd.value);
  const today = dayjs();

  const { value, unit } = periodMap[activeRange.value];

  // 次の期間を仮計算
  const nextStart = start.add(value, unit);
  const nextEnd = end.add(value, unit);

  // 未来（今日より後）に進む場合はブロック
  if (nextStart.isAfter(today) || nextEnd.isAfter(today)) {
    return; // 何もしない
  }

  periodStart.value = nextStart.format("YYYY-MM-DD");
  periodEnd.value = nextEnd.format("YYYY-MM-DD");
}

// 日付フォーマット
function formatDate(date: dayjs.Dayjs | string | null, fmt: string) {
  return date ? dayjs(date).format(fmt) : "";
}

// 期間フォーマット
function formatPeriod(
  startDate: string,
  endDate: string,
  type: "html" | "text" = "html"
) {
  const start = dayjs(startDate);
  const end = dayjs(endDate);
  const sameYear = start.year() === end.year();

  // 年月日
  const startYear = `${start.year()}年`;
  const endYear = `${end.year()}年`;
  const startMD = formatDate(start, "M月D日");
  const endMD = formatDate(end, "M月D日");

  let dateStr = "";
  if (type === "html") {
    // HTML形式
    if (sameYear) {
      dateStr = `${startYear} <span>${startMD}～${endMD}</span>`;
    } else {
      dateStr = `${startYear} <span>${startMD}</span>～${endYear} <span>${endMD}</span>`;
    }
    return dateStr;
  }

  // テキスト形式
  if (sameYear) {
    dateStr = `${startYear}${startMD}～${endMD}`;
  } else {
    dateStr = `${startYear}${startMD}～${endYear}${endMD}`;
  }
  return dateStr;
}

// 表示データセット
async function set() {
  // データ取得済みフラグOFF
  isDataStored.value = false;

  // データ取得
  const myGraph = new MyGraph();
  const [_model, response, err] = await myGraph.getData(
    periodStart.value,
    periodEnd.value
  );

  // エラー判定
  if (err) {
    const status = err.error.response.status;
    const decodedMessage = decodeURIComponent(
      err.error?.response?.data?.message
    );
    // セッションエラー
    if (status === 408) sessionErr.value = true;
    errorDialogSet.open(decodedMessage);
    return { dailyNotes: [], dailyFeelings: [] };
  }

  // 初期閲覧フラグセット
  initialReadFlag.value = response.data.chartHiddenFlag; // 初回閲覧フラグセット

  // データセット
  bodyConditions.value = response.data.dailyConditions; // 体調データ
  dailyNoteItems.value = response.data.dailyNotes; // 症状・こころノート
  dailyFeelingItems.value = response.data.dailyFeelings; // 日々の気持ち
  treatmentItems.value = response.data.userTreatments; // 治療の変化
  treatmentModalProps.diseaseOptions = response.data.userDiseases; // 治療履歴モーダルの病気選択肢

  // データ取得済みフラグON
  isDataStored.value = true;
}

// --- Event Handlers -------------------------------------------------------

// 治療履歴モーダルクローズ
function onCloseTreatmentHistory() {
  isTreatmentHistory.value = false;
}

// 治療状況の見方ポップアップクローズ
function onCloseTreatmentTips() {
  isTreatmentTips.value = false;
}

// 初回説明クローズ
async function onCloseIntro() {
  initialReadFlag.value = true; // 初回閲覧フラグ解除

  const myGraph = new MyGraph();
  const [_model, _response, err] = await myGraph.setChartHiddenFlag();

  // エラー判定
  if (err) {
    const status = err.error.response.status;
    const decodedMessage = decodeURIComponent(
      err.error?.response?.data?.message
    );
    // セッションエラー
    if (status === 408) sessionErr.value = true;
    errorDialogSet.open(decodedMessage);
    return { dailyNotes: [], dailyFeelings: [] };
  }
}

// 期間選択タブ変更
function onActiveRangeChange(key: RangeKey) {
  // 期間選択タブ変更
  activeRange.value = key;
  // 期間再設定
  const { value, unit } = periodMap[activeRange.value];
  periodStart.value = dayjs().subtract(value, unit).format("YYYY-MM-DD");
  periodEnd.value = dayjs().format("YYYY-MM-DD");
}

// 治療履歴ボタン押下
function onTreatmentHistory() {
  if (treatmentItems.value.length === 0) return;
  isTreatmentHistory.value = true;
}

// 治療履歴もっと見るボタン押下
function onTreatmentMore() {
  if (treatmentItems.value.length === 0) return;
  isTreatmentHistory.value = true;
}

// 治療履歴ボタン押下
function onTreatmentTips() {
  isTreatmentTips.value = true;
}

// 症状・こころノートもっと見るボタン押下
function onDailyNoteMore() {
  router.push({
    name: "MyReportDailyNote",
    params: {
      yearMonth: dayjs().format("YYYY-MM"),
    },
    query: {
      returnTab: "graph",
      returnRoute: "MyReport",
    },
  });
}

// 記録画面へ遷移
function onClickRecordCondition() {
  router.push({
    name: "home",
  });
}

// 記録画面へ遷移
function onClickRecordSymptom() {
  router.push({
    name: "home",
    query: {
      date: dayjs().format("YYYY-MM-DD"),
      tab: "symptom",
    },
  });
}

// 記録画面へ遷移
function onClickRecordFeeling() {
  router.push({
    name: "home",
    query: {
      date: dayjs().format("YYYY-MM-DD"),
      tab: "feeling",
    },
  });
}

// 日付バー固定判定（モバイルのみ）
function handleDateChangeFixed() {
  if (window.innerWidth > mobileBreakpoint) {
    isDateChangeFixed.value = false;
    return;
  }
  if (!dateChangeTriggerRef.value) return;
  const triggerTop = dateChangeTriggerRef.value.getBoundingClientRect().top;
  isDateChangeFixed.value = triggerTop <= 0;
}

// リサイズ時にも固定状態を再評価
function handleResize() {
  // SP/PCの切替時に、体調グラフタイトルのフォントサイズも追従させる
  isMobileScreen.value = window.innerWidth <= mobileBreakpoint;
  titleCond.textStyle.fontSize = isMobileScreen.value ? "16px" : "18px";
  titleAvg.textStyle.fontSize = isMobileScreen.value ? "14px" : "16px";
  handleDateChangeFixed();
}

// ---- Vue Lifecycle Hooks ------------------------------------
onMounted(async () => {
  await set();
  await nextTick();

  // wrapperスクロールとwindowスクロールの両方で固定判定する
  wrapperEl = document.querySelector(".wrapper");
  handleDateChangeFixed();

  window.addEventListener("scroll", handleDateChangeFixed, { passive: true });
  window.addEventListener("resize", handleResize);
  wrapperEl?.addEventListener("scroll", handleDateChangeFixed, {
    passive: true,
  });
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", handleDateChangeFixed);
  window.removeEventListener("resize", handleResize);
  wrapperEl?.removeEventListener("scroll", handleDateChangeFixed);
});

watch([periodStart, periodEnd], async () => await set());
// 初回説明の開閉でレイアウトが変わるため固定判定を再実行
watch(initialReadFlag, async () => {
  await nextTick();
  handleDateChangeFixed();
});
// 期間が7日以内かどうか判定
const isPeriodWithin7Days = computed(() => {
  if (!periodStart.value || !periodEnd.value) return false;

  const start = dayjs(periodStart.value);
  const end = dayjs(periodEnd.value);
  const sevenDaysAgo = dayjs().subtract(6, "day");
  const today = dayjs();

  return (
    start.isSameOrAfter(sevenDaysAgo, "day") && end.isSameOrBefore(today, "day")
  );
});
// statusあり、またはsubNumberが1のものに限定して表示
const filteredTreatmentItems = computed(() =>
  treatmentItems.value
    .filter(
      (item) =>
        item.status || // ステータスあり
        item.isNew || // 開始日ある治療
        (item.subNumber === 1 && item.title !== "治療をしていない") // 初回登録 かつ 治療していない以外
    )
    .map((item) => {
      if (item.isNew) {
        return {
          ...item,
          status: "新しい治療",
        };
      }
      return { ...item };
    })
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!initialReadFlag.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[0] || (_cache[0] = _createElementVNode("img", { src: "/server/necs/images/light_bulb.svg" }, null, -1)),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("myreport_graph_message_intro")), 1)
          ]),
          _createElementVNode("img", {
            onClick: onCloseIntro,
            class: "summary-top-intro-close",
            src: "/server/necs/images/close_black_24dp.png"
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(rangeMap, (range) => {
          return _createElementVNode("li", {
            key: range.key,
            class: _normalizeClass(["my-report-top-date-item", { 'is-active': activeRange.value === range.key }]),
            onClick: ($event: any) => (onActiveRangeChange(range.key))
          }, _toDisplayString(range.label), 11, _hoisted_5)
        }), 64))
      ]),
      _createElementVNode("div", {
        ref_key: "dateChangeTriggerRef",
        ref: dateChangeTriggerRef
      }, null, 512),
      _createElementVNode("div", {
        ref_key: "dateChangeRef",
        ref: dateChangeRef,
        class: _normalizeClass(["my-report-top-date-change", { 'is-fixed': isDateChangeFixed.value }])
      }, [
        _createElementVNode("div", {
          class: "my-report-top-date-change-icon",
          onClick: prevPeriod
        }, _cache[1] || (_cache[1] = [
          _createElementVNode("img", {
            src: "/server/necs/images/arrow_left_888.svg",
            alt: ""
          }, null, -1)
        ])),
        _createElementVNode("div", {
          innerHTML: formatPeriod(periodStart.value, periodEnd.value),
          class: "my-report-top-date-change-period"
        }, null, 8, _hoisted_6),
        (_unref(dayjs)(periodEnd.value).isSame(_unref(dayjs)(), 'day'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[2] || (_cache[2] = [
              _createElementVNode("img", {
                src: "/server/necs/images/arrow_right_ddd.svg",
                alt: ""
              }, null, -1)
            ])))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "my-report-top-date-change-icon",
              onClick: nextPeriod
            }, _cache[3] || (_cache[3] = [
              _createElementVNode("img", {
                src: "/server/necs/images/arrow_right_888.svg",
                alt: ""
              }, null, -1)
            ])))
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (isDataStored.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  (bodyConditions.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createVNode(ConditionLineChart, {
                          bodyConditions: bodyConditions.value,
                          pointSize: 8,
                          startDate: periodStart.value,
                          endDate: periodEnd.value,
                          titleCond: titleCond,
                          titleAvg: titleAvg,
                          class: "condition-line-chart"
                        }, null, 8, ["bodyConditions", "startDate", "endDate", "titleCond", "titleAvg"])
                      ]))
                    : (!isPeriodWithin7Days.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("myreport_graph_message_notrecord_condition")), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("myreport_graph_label_condition")), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("p", {
                              class: "item-unrecorded-text pc-only",
                              innerHTML: _ctx.$t('myreport_graph_message_norecord_condition_pc')
                            }, null, 8, _hoisted_19),
                            _createElementVNode("p", {
                              class: "item-unrecorded-text sp-only",
                              innerHTML: _ctx.$t('myreport_graph_message_norecord_condition_sp')
                            }, null, 8, _hoisted_20),
                            _createElementVNode("button", {
                              class: "item-unrecorded-button",
                              onClick: onClickRecordCondition
                            }, _toDisplayString(_ctx.$t("myreport_graph_button_norecord_condition")), 1),
                            _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("myreport_graph_message_norecord_condition_note")), 1)
                          ])
                        ]))
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t("myreport_graph_message_treatment_period", {
                    span: rangeMap[activeRange.value].label,
                  })), 1),
                      _createElementVNode("img", {
                        onClick: onTreatmentTips,
                        src: "/server/necs/images/icon_info.svg",
                        alt: ""
                      })
                    ]),
                    (
                filteredTreatmentItems.value.length > 0 ||
                (filteredTreatmentItems.value.length === 0 && isPeriodWithin7Days.value)
              )
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: onTreatmentHistory,
                          class: _normalizeClass({
                'item-button-treatment-history': true,
                'is-unrecorded': filteredTreatmentItems.value.length === 0,
              })
                        }, _toDisplayString(_ctx.$t("myreport_graph_button_treatment_history")), 3))
                      : _createCommentVNode("", true)
                  ]),
                  (filteredTreatmentItems.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("ul", _hoisted_27, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTreatmentItems.value.slice(
                  0,
                  _MAX_DISPLAY_COUNT
                ), (item) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: item.id,
                              class: "item-treatment-change-row"
                            }, [
                              _createElementVNode("p", _hoisted_28, _toDisplayString(formatDate(item.date, "YYYY年M月D日")), 1),
                              _createElementVNode("p", _hoisted_29, [
                                _createElementVNode("span", null, _toDisplayString(item.status) + "：" + _toDisplayString(item.title), 1),
                                (item.detail)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, "（" + _toDisplayString(item.detail) + "）", 1))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ]),
                        (filteredTreatmentItems.value.length > _MAX_DISPLAY_COUNT)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: onTreatmentMore,
                              class: "item-treatment-change-more-button"
                            }, _toDisplayString(_ctx.$t("myreport_graph_button_treatment_more", {
                  count: filteredTreatmentItems.value.length - _MAX_DISPLAY_COUNT,
                })), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : (!isPeriodWithin7Days.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$t("myreport_graph_message_notrecord_treatment")), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createElementVNode("p", _hoisted_34, [
                            _createTextVNode(_toDisplayString(formatPeriod(periodStart.value, periodEnd.value, "text")) + " ", 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("myreport_graph_message_treatment_nochange")), 1)
                          ])
                        ]))
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.$t("myreport_graph_label_symptom")), 1)
                    ])
                  ]),
                  (dailyNoteItems.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createElementVNode("ul", _hoisted_40, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dailyNoteItems.value.slice(0, _MAX_DISPLAY_COUNT), (item) => {
                            return (_openBlock(), _createElementBlock("li", {
                              class: "item-daily-note-row",
                              key: item.id
                            }, [
                              _createElementVNode("p", _hoisted_41, _toDisplayString(item.content), 1),
                              _createElementVNode("div", _hoisted_42, [
                                _createElementVNode("span", _hoisted_43, _toDisplayString(formatDate(item.date, "YYYY年M月D日(ddd)")), 1),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["row-bottom-category", item.categoryClass])
                                }, _toDisplayString(item.categoryLabel), 3)
                              ])
                            ]))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_44, [
                          (dailyNoteItems.value.length > _MAX_DISPLAY_COUNT)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: onDailyNoteMore,
                                class: "item-daily-note-more-button",
                                type: "button"
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.$t("myreport_graph_button_symptom_more")) + " ", 1),
                                _cache[4] || (_cache[4] = _createElementVNode("img", {
                                  src: "/server/necs/images/arrow-right_icon.png",
                                  alt: ""
                                }, null, -1))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : (!isPeriodWithin7Days.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.$t("myreport_graph_message_notrecord_symptom")), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                          _createElementVNode("p", {
                            class: "item-unrecorded-text pc-only",
                            innerHTML: _ctx.$t('myreport_graph_message_norecord_symptom_pc')
                          }, null, 8, _hoisted_48),
                          _createElementVNode("p", {
                            class: "item-unrecorded-text sp-only",
                            innerHTML: _ctx.$t('myreport_graph_message_norecord_symptom_sp')
                          }, null, 8, _hoisted_49),
                          _createElementVNode("button", {
                            class: "item-unrecorded-button",
                            onClick: onClickRecordSymptom
                          }, _toDisplayString(_ctx.$t("myreport_graph_button_norecord_symptom")), 1),
                          _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.$t("myreport_graph_message_norecord_symptom_note")), 1)
                        ]))
                ]),
                _createElementVNode("div", _hoisted_51, [
                  (dailyFeelingItems.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _createVNode(FeelingDoughnutChart, {
                          title: _ctx.$t('myreport_graph_label_feeling'),
                          class: "feeling-doughnut-chart",
                          items: dailyFeelingItems.value
                        }, null, 8, ["title", "items"])
                      ]))
                    : (!isPeriodWithin7Days.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.$t("myreport_graph_label_feeling")), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("p", _hoisted_58, _toDisplayString(_ctx.$t("myreport_graph_message_notrecord_feeling")), 1)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("div", _hoisted_61, [
                              _createElementVNode("p", _hoisted_62, _toDisplayString(_ctx.$t("myreport_graph_label_feeling")), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_63, [
                            _createElementVNode("p", {
                              class: "item-unrecorded-text pc-only",
                              innerHTML: _ctx.$t('myreport_graph_message_norecord_feeling_pc')
                            }, null, 8, _hoisted_64),
                            _createElementVNode("p", {
                              class: "item-unrecorded-text sp-only",
                              innerHTML: _ctx.$t('myreport_graph_message_norecord_feeling_sp')
                            }, null, 8, _hoisted_65),
                            _createElementVNode("button", {
                              class: "item-unrecorded-button",
                              onClick: onClickRecordFeeling
                            }, _toDisplayString(_ctx.$t("myreport_graph_button_norecord_feeling")), 1),
                            _createElementVNode("p", _hoisted_66, _toDisplayString(_ctx.$t("myreport_graph_message_norecord_feeling_note")), 1)
                          ])
                        ]))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (isTreatmentHistory.value)
        ? (_openBlock(), _createBlock(TreatmentHistory, {
            key: 0,
            diseases: treatmentModalProps.diseaseOptions,
            limitDate: periodStart.value,
            onClose: onCloseTreatmentHistory
          }, null, 8, ["diseases", "limitDate"]))
        : _createCommentVNode("", true),
      (isTreatmentTips.value)
        ? (_openBlock(), _createBlock(TreatmentTips, {
            key: 1,
            span: rangeMap[activeRange.value].label,
            onClose: onCloseTreatmentTips
          }, null, 8, ["span"]))
        : _createCommentVNode("", true),
      (_unref(errorDialogSet).show)
        ? (_openBlock(), _createBlock(ErrorDialog, _mergeProps({ key: 2 }, _unref(errorDialogSet), {
            onOk: _unref(errorDialogSet).close,
            onCancel: _unref(errorDialogSet).close
          }), null, 16, ["onOk", "onCancel"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})